import React from 'react';

import BlockAccessPage from '../../../../../components/BlockAccess/BlockAccessPage';
import {checkIfHasPermissions} from '../../../../../components/Menu/Utils/commonFunctions';
import BusTravelTable from '../../../../../components/Table/BusinessTravelTable';
import EmpTable from '../../../../../components/Table/EmpTable';
import Tabs from '../../../../../components/Tabs/Tabs';
import {PermissionEnum} from '../../../../../constants/permissionsEnum';
import TranslatedText from '../../../../../libraries/I18N/TranslatedText';
import {accessModule} from '../../../../../store/companyStore/companyDetailsStore';
import {shouldBlockModuleAccess} from '../../../../../utils/SubscriptionHelper';

const Travel: React.FC<{
  selectedYear: string;
  facilityId: string;
}> = ({selectedYear, facilityId}) => {
  const IPTab = [
    {
      id: 'emp',
      name: <TranslatedText translationKey="Employee Commute" />,
      component: shouldBlockModuleAccess(accessModule.scope3) ? (
        <BlockAccessPage />
      ) : (
        <EmpTable selectedYear={selectedYear} facilityId={facilityId} />
      ),
      hidden: !checkIfHasPermissions(PermissionEnum.OrgManagerEmployeeCommute)
    },
    {
      id: 'bus',
      name: <TranslatedText translationKey="Business Travel" />,
      component: shouldBlockModuleAccess(accessModule.scope3) ? (
        <BlockAccessPage />
      ) : (
        <BusTravelTable selectedYear={selectedYear} facilityId={facilityId} />
      ),
      hidden: !checkIfHasPermissions(PermissionEnum.OrgManagerBusinessTravel)
    }
  ].filter((item) => !item.hidden);

  return <Tabs array={IPTab} type="card" />;
};

export default Travel;
